module.exports = __webpack_public_path__ + "img/forum.db3f0cc4.jpeg";